import React from 'react';
import { PaperDarkBG } from '../kits';

function SectionA() {
  return (
    <PaperDarkBG>
      {/* Die oben definierte Section */}
      <section className="py-20 sm:py-16 md:py-20">
        <div className="container mx-auto text-center px-10">
          <h1 className="text-xl sm:text-xl md:text-xl font-mono text-gray-50 mb-4">
            DAS EINZIGE WAS SCHLIMMER IST, <br/><span className="text-organge-50">NICHT ANZUFANGEN</span> UM ZU <span className="text-orange-300">SCHEITERN</span>
          </h1>
          <p className="italic text-xs sm:text-xs md:text-xs font-mono text-gray-50">
            by Denis Bitter
          </p>
        </div>
      </section>
      
      {/* Weitere Sections oder Inhalte hier */}
    </PaperDarkBG>
  );
}

export default SectionA;